export default "__VITE_ASSET__4093cd4b__"